import {NgModule} from '@angular/core';
import {HttpRawMaterialsService} from '@infrastructure/http/raw-materials/http-raw-materials.service';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {CrudOverviewDataModule, EditorHeaderModule, SplitButtonModule} from '@vdw/angular-component-library';
import {AddRawMaterialComponent} from './add/add-raw-material.component';

@NgModule({
  imports: [TextileDataSharedModule, EditorHeaderModule, CrudOverviewDataModule, SplitButtonModule],
  declarations: [AddRawMaterialComponent],
  providers: [HttpRawMaterialsService]
})
export class RawMaterialModule {}
